import React from "react";

const HelpCenterIcon = (props: any) => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.7207 23.5999V9.71516C4.7207 6.43121 7.38531 3.7666 10.6693 3.7666H14.0684"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M24.5544 7.30957V19.2067C24.5544 21.6264 22.5812 23.5997 20.1614 23.5997H10.1367"
        stroke="currentColor"
        stroke-width="1.13719"
        stroke-miterlimit="10"
      />
      <path
        d="M15.5524 10.8818V18.5732H14.5586V10.8818H15.5524Z"
        fill="currentColor"
      />
      <path
        d="M15.0483 9.68639C15.5733 9.68639 15.9989 9.26078 15.9989 8.73577C15.9989 8.21076 15.5733 7.78516 15.0483 7.78516C14.5233 7.78516 14.0977 8.21076 14.0977 8.73577C14.0977 9.26078 14.5233 9.68639 15.0483 9.68639Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HelpCenterIcon;
